<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="businessverifyform"
          status-icon
          :model="businessverifyform"
          :rules="rules"
          label-width="120px"
          style="width: 100%;"
          v-loading="loading"
          :element-loading-text="loadingText"
        >
        <el-row>
            <el-col>
              <el-form-item label="商户名称" prop="BusinessName">
                <el-input
                  v-model="businessverifyform.BusinessName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
              <el-form-item label="银行卡号" prop="Account">
                <el-input
                  v-model="businessverifyform.Account" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
              <el-form-item label="验资方式" prop="MoneyOrCode">
                <el-radio-group  v-model="businessverifyform.MoneyOrCode" @change="MoneyOrCodeChange">
                 <el-radio label="1">验资金额</el-radio>
                 <el-radio label="2">短信验证码</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
              <el-form-item :label="MoneyOrCodeLabel" prop="VerifyNum">
                <el-input v-model="businessverifyform.VerifyNum"></el-input>
              </el-form-item>
            </el-col>
        </el-row>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center;">
        <el-button type="primary" @click="Onsubmit('businessverifyform')">提交</el-button>
        <el-button @click="OnCancel">取消</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  .avatar {
    width: 80px;
    height: 80px;
    display: block;
  }
</style>

<script>
import WebApis from "../../../apis";
// import utils from "../../../../../../utils";
// import { showLoading, hideLoading } from "../../../../../../loading";
// import ZJApp from "../../../../../app";


export default {
  name: "BusinessVerifyPage",
  data() {
    return {
      businessverifyform: {
        Account :"",
        BusinessCode:"",
        BusinessName:"",
        MoneyOrCode:"1",
        VerifyNum:""
      },
      rules: {
        Account:[
            { required: true, message: "请输入银行卡号", trigger: "change" }
        ],
        VerifyNum:[
          { required: true, message: "请输入验资金额/短信验证码", trigger: "change" }
        ]
      },
      loading: false,
      loadingText: "加载中...",
      MoneyOrCodeLabel:"验资金额"
    };
  },
  props: {
    Business_Code: {
      type: String,
      default: ""
    },
    Business_Name: {
      type: String,
      default: ""
    },
    Business_Account: {
      type: String,
      default: ""
    }
  },
  created: function () {
    this.init();
  },
  computed: {
   
  },
  methods: {
    // 初始化
    init() {
       this.businessverifyform.BusinessCode=this.Business_Code;
       this.businessverifyform.BusinessName=this.Business_Name;
       this.businessverifyform.Account=this.Business_Account;
    },
    Onsubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
           
            let VerifyMessageCodeAndRandomAmount={
                Account:this.businessverifyform.Account,
                SubMerchantNo:this.businessverifyform.BusinessCode,
                VerificationCode:this.businessverifyform.MoneyOrCode==2? this.businessverifyform.VerifyNum:"",
                RandomAmount:this.businessverifyform.MoneyOrCode==1? this.businessverifyform.VerifyNum:""
            }

           new WebApis.BusinessApi().VerifyMessageCodeAndRandomAmountService(VerifyMessageCodeAndRandomAmount).then((res)=>{
                
                console.log("验证返回",res);
                if (res.RspCode=="1") {

                   if(res.data.Data.Status==0)
                    {
                        this.$message({
                                message: "提交成功，等待审核!",
                                type: "success",
                          });

                          this.GetBusiessStatus(this.businessverifyform.BusinessCode);
                    }
                    else if(res.data.Data.Status==1)
                    {
                         this.$message({
                                showClose: true,
                                message: res.data.Data.Response.Msg,
                                type: "error",
                          });
                    }
                }
                else{
                    this.$message({
                        showClose: true,
                        message: "提交失败!" + res.RspMsg,
                        type: "error",
                    });
                }
            }).catch((e) => {
                this.$message({
                    showClose: true,
                    message: e.RspMsg ? "提交失败" + e.RspMsg : "提交失败",
                    type: "error",
                });
                return false;
            });
            this.$emit("clickOk", {});

        } else {
          this.$message({
            showClose: true,
            message: "填写内容不正确!",
            type: "error",
          });
          return false;
        }
      });
    },
    OnCancel() {
      this.$emit("clickCancel", {});
    },
    MoneyOrCodeChange:function(val)
    {
      let that=this;
      that.MoneyOrCodeLabel=(val==="1")?"验资金额":"短信验证码";
    },
    GetBusiessStatus(thisBusinessCode) {
      
      const that = this;
      
      let QrySubMerchantInfo={
        SubMerId:thisBusinessCode
      }


       new WebApis.BusinessApi()
          .QrySubMerchantInfoService(QrySubMerchantInfo)
          .then((r)=>{
            console.log("获取状态",r);
                if (r.RspCode != "1") {
                  that.$message({ type: "success", message: "获取状态失败!" });
                }
          }).catch((e)=>{
            console.log("获取状态失败",e);
            that.$message({
                    showClose: true,
                    message: e ? "获取状态失败!" + e.RspMsg : "获取状态失败!",
                    type: "error",
                  });
          });
    },
  },
};
</script>
